import React, { Component } from 'react'

import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import './CorporateShippingAddress.css';
import CorporateLayoutWrapper from '../../../component/CorporateLayoutWrapper/'
import Footer from '../../../component/Footer/Footer';
import "react-responsive-modal/styles.css";
import Loader from 'react-loader-advanced';
import { newAddressAdd, doAddNewAddressRes } from '../../../action/AddNewAddressAction';
import { addressShowList, doShowAddressListRes } from '../../../action/ShowAddressListAction';
import { addressDelete, doDeleteAddressRes } from '../../../action/DeleteAddressAction';
import loaderImg from '../../../assets/images/loader-example.gif';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
// import Loader from 'react-loader-advanced';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

class CorporateShippingAddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAddressSubmited: false,
            newAddrModalPopup: false,
            firstName: '',
            lastName: '',
            company: '',
            streetAddress: '',
            City: '',
            postalCode: '',
            phoneNumber: '',
            addressBook: '',
            stateProvince: '',
            showAddressData: [],
            addressShow: true,
            addradio: localStorage.getItem('addressId') ? localStorage.getItem('addressId') : 0,
            isLoader: false,

            columns: [],
            dataCsv: [],
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    clickNewAddress() {
        this.setState({
            newAddrModalPopup: true
        })
    }

    onCloseModal = () => {
        this.setState({
            newAddrModalPopup: false
        })
    }


    addressvalidate(values) {
        const errors = {};
        if (values.firstName && values.firstName.trim() === '') {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === undefined) {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === '') {
            errors.firstName = '*Please enter firstName';
        }

        if (values.lastName && values.lastName.trim() === '') {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === null) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === undefined) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === '') {
            errors.lastName = '*Please enter lastName';
        }

        if (values.company && values.company.trim() === '') {
            errors.company = '*Please enter company';
        } else if (values.company === null) {
            errors.company = '*Please enter company';
        } else if (values.company === undefined) {
            errors.company = '*Please enter company';
        } else if (values.company === '') {
            errors.company = '*Please enter company';
        }

        if (values.streetAddress && values.streetAddress.trim() === '') {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === null) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === undefined) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === '') {
            errors.streetAddress = '*Please enter streetAddress';
        }

        if (values.city && values.city.trim() === '') {
            errors.city = '*Please enter city';
        } else if (values.city === null) {
            errors.city = '*Please enter city';
        } else if (values.city === undefined) {
            errors.city = '*Please enter city';
        } else if (values.city === '') {
            errors.city = '*Please enter city';
        }

        if (values.postalCode && values.postalCode.trim() === '') {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === null) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === undefined) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === '') {
            errors.postalCode = '*Please enter postalCode';
        }


        if (values.phoneNumber && values.phoneNumber.trim() === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === null) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === undefined) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber.length !== 10) {
            errors.phoneNumber = '*Please enter valid phone number.';
        }


        if (values.stateProvince && values.stateProvince.trim() === '') {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === null) {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === undefined) {
            errors.stateProvince = '*Please enter state';
        } else if (values.stateProvince === '') {
            errors.stateProvince = '*Please enter state';
        }

        //   if(values.addressBook && values.addressBook.trim() === ''){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === null){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === undefined){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === ''){
        //     errors.addressBook = '*Please enter addressBook';
        //   }     
        return errors;
    }


    AddressHandelSubmit = e => {
        e.preventDefault();
        this.setState({
            isAddressSubmited: true,
        }, () => { });
        this.addressvalidate(this.state);
        const errors = this.addressvalidate(this.state);
        if (Object.keys(errors).length === 0) {
            let requestData = {
                user_id: localStorage.getItem('userId'),
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                company: this.state.company,
                streetAddress: this.state.streetAddress,
                city: this.state.city,
                postalCode: this.state.postalCode,
                phoneNumber: this.state.phoneNumber,
                stateProvince: this.state.stateProvince
                // addressBook:this.state.addressBook,
            }
            this.setState({
                isLoader: true
            })
            this.props.newAddressAdd(requestData)
        }
    }

    componentDidMount() {


        this.setState({
            dataCsv: this.props && this.props.location && this.props.location.state && this.props.location.state.csvData
        })


        const data = {
            user_id: localStorage.getItem('userId')
        }
        this.setState({
            isLoader: true
        })
        this.props.addressShowList(data)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doAddNewAddressRes && nextProps.doAddNewAddressRes.user) {
            if (nextProps.doAddNewAddressRes.user && nextProps.doAddNewAddressRes.user.AddNewAddressRes) {
                if (nextProps.doAddNewAddressRes.user.AddNewAddressRes && nextProps.doAddNewAddressRes.user.AddNewAddressRes.result === true) {
                    window.location.href = ''
                    this.setState({
                        newAddrModalPopup: false,
                        addressShow: true,
                        isLoader: false
                    }, () => {
                        if (this.state.addressShow) {
                            const data = {
                                user_id: localStorage.getItem('userId')
                            }
                            this.props.addressShowList(data)
                        }
                    })
                } else {
                    this.setState({
                        isLoader: false,
                        newAddrModalPopup: false
                    })
                }
            }
        }

        if (nextProps.doShowAddressListRes && nextProps.doShowAddressListRes.user) {
            if (nextProps.doShowAddressListRes.user && nextProps.doShowAddressListRes.user.ShowAddressListRes) {
                if (nextProps.doShowAddressListRes.user.ShowAddressListRes && nextProps.doShowAddressListRes.user.ShowAddressListRes.result === true && this.state.addressShow) {

                    this.setState({
                        showAddressData: nextProps.doShowAddressListRes.user.ShowAddressListRes.address,
                        addressID: nextProps.doShowAddressListRes.user.ShowAddressListRes.address[0].id,
                        addressShow: false,
                        isLoader: false,
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doDeleteAddressRes && nextProps.doDeleteAddressRes.user) {
            if (nextProps.doDeleteAddressRes.user && nextProps.doDeleteAddressRes.user.DeleteAddressRes) {
                if (nextProps.doDeleteAddressRes.user.DeleteAddressRes && nextProps.doDeleteAddressRes.user.DeleteAddressRes.results === true) {
                    window.location.href = '/checkoutshippingaddress'
                    this.setState({
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }
    }

    addressHandelChange = (e) => {
        this.setState({
            addradio: e
        })
        localStorage.setItem('addressId', e)
    }

    deleteAddress = (id) => {
        const data = {
            add_id: id
        }
        this.setState({
            isLoader: true
        })
        this.props.addressDelete(data)

    }

    checkOutValidation = () => {
        if (this.state.showAddressData.length === 0) {
            this.setState({
                newAddrModalPopup: true
            })
        } else {
            this.props.history.push('/checkout', {
                addressId: this.state.addressID
            })

        }
    }


    onRowEditComplete1 = (e) => {
        console.log('e141', e)
        let dataCsv = [...this.state.dataCsv];
        let { newData, index } = e;

        dataCsv[index] = newData;

        this.setState({ dataCsv });
    }

    textEditor = (options) => {

        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    }





    render() {

        const spinner = <span><img src={loaderImg} alt="" /></span>;


        return (
            <React.Fragment>
                <Loader show={this.state.isLoader} message={spinner}>
                    <CorporateLayoutWrapper />
                    <main className="main">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/corporate-checkout">Corporate Checkout</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Corporate Address</li>
                                </ol>
                            </div>
                            {/* End .container  */}
                        </nav>

                        <div className="container">
                            <ul className="checkout-progress-bar">
                                <li className="active">
                                    <span>Shipping</span>
                                </li>
                                <li>
                                    <span>Review &amp; Payments</span>
                                </li>
                            </ul>


                            <DataTable value={this.state.dataCsv} editMode="row" dataKey="id" onRowEditComplete={this.onRowEditComplete1} responsiveLayout="scroll">
                                <Column field="Name" header="Name" editor={(options) => this.textEditor(options)} style={{ width: '20%' }}></Column>

                                <Column field="Email Id" header="Email Id" style={{ width: '20%' }}></Column>

                                <Column field="Company Name" header="Company Name" body={this.statusBodyTemplate} style={{ width: '20%' }}></Column>

                                <Column field="City" header="City" body={this.priceBodyTemplate} style={{ width: '20%' }}></Column>

                                <Column field="Address" header="Address" body={this.priceBodyTemplate} style={{ width: '20%' }}></Column>

                                <Column field="Postal Code" header="Postal Code" body={this.priceBodyTemplate} style={{ width: '20%' }}></Column>

                                <Column field="State" header="State" body={this.priceBodyTemplate} style={{ width: '20%' }}></Column>

                                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                            </DataTable>
                        </div>
                        <div className='mt-5'></div>
                        {/* End .container  */}


                    </main>
                </Loader>
                {/* End .main */}




                <Footer />
            </React.Fragment>
        )
    }
}

CorporateShippingAddress.propTypes = {
    doAddNewAddressRes: PropTypes.any,
    doShowAddressListRes: PropTypes.any,
    doDeleteAddressRes: PropTypes.any
};

const mapStateToProps = createStructuredSelector({
    doAddNewAddressRes: doAddNewAddressRes,
    doShowAddressListRes: doShowAddressListRes,
    doDeleteAddressRes: doDeleteAddressRes
});

function mapDispatchToProps(dispatch) {
    return {
        newAddressAdd: (data) => dispatch(newAddressAdd(data)),
        addressShowList: (data) => dispatch(addressShowList(data)),
        addressDelete: (data) => dispatch(addressDelete(data))
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(CorporateShippingAddress)